'use client'

import './rebate-recommendation-cards.css'
import Link from 'next/link'
import { buttonVariants } from '@/components/ui/button'
import { ChevronRight } from 'lucide-react'
import { HorizontalCarousel } from '@/components/brand-kit/horizontal-carousel'
import { ProductCarouselCard, type CarouselProduct } from '@/components/brand-kit/product-carousel-card'

const railCardClasses = { shell: "rr-shell", image: "rr-image", title: "rr-title", titleLink: "rr-titleLink", cta: "rr-cta", brand: "rr-brand", price: "rr-price", imageFrame: "rr-imageFrame", info: "rr-info", priceRow: "rr-priceRow", badgePosition: "rr-badgePosition", badge: "rr-badge", frame: "rr-frame", save: "rr-save", compare: "rr-compare" }

/**
 * These cards still render in the initial server HTML. Sending the compact
 * display models across this boundary avoids serializing every card element
 * again in the server-component stream; no raw catalog rows reach the browser.
 */
export function RebateRecommendationCards({ cards, badge, badgeColor }: { cards: CarouselProduct[]; badge?: string; badgeColor?: string }) {
  return cards.map((product, index) => (
    <ProductCarouselCard key={`${product.brand}-${product.title}-${index}`} product={badge === undefined ? product : { ...product, badge, badgeColor }} styleClasses={railCardClasses} imageNamesLink />
  ))
}

interface RebateRecommendationRailProps {
  cards: CarouselProduct[]
  badge?: string
  badgeColor?: string
  eyebrow: string
  title: string
  description: string
  bgClass: string
  ctaLink: string
  ctaText: string
}

/** Preserve the complete server-rendered rail while transporting display data once. */
export function RebateRecommendationRail({ cards, badge, badgeColor = 'bg-[#0d8449]', eyebrow, title, description, bgClass, ctaLink, ctaText }: RebateRecommendationRailProps) {
  return (
    <section className="my-8">
      <div className="max-w-[1320px] mx-auto px-6 md:px-8">
        <HorizontalCarousel
          eyebrow={eyebrow}
          title={title}
          description={description}
          bgClass={bgClass}
          className="!mt-0"
        >
          <RebateRecommendationCards cards={cards} badge={badge} badgeColor={badgeColor} />
        </HorizontalCarousel>

        {/* Mobile CTA — surface a browse-all action below the carousel
            on small screens. The carousel header already exposes one on
            md+; this is the mobile fallback. */}
        {ctaLink && (
          <div className="mt-4 md:hidden text-center">
            <Link href={ctaLink} className={buttonVariants({ variant: "outline", size: "sm" })}>
              {ctaText}
              <ChevronRight className="w-4 h-4 ml-1" />
            </Link>
          </div>
        )}
      </div>
    </section>
  )
}
